// extracted by mini-css-extract-plugin
export default {"invalidInput":"ErrorLabel_invalidInput__NNxVU","yellowLabel":"ErrorLabel_yellowLabel__-6j33","greenLabel":"ErrorLabel_greenLabel__wavM5"};